import { faClose, faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState, useContext } from "react";
import NSSelector from "../NSSelector/NSSelector";
import { TimelineContext } from "../../helpers/Context";
import { isMobile } from "react-device-detect";
import { OptionsEvaluaRitmo } from "../../helpers/Constants";
import NSMultiSelector from "../NSMultiSelector/NSMultiSelector";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogEvaluaRitmo = ({
  icon,
  text,
  callbackConfirm,
  callbackCancel,
  status,
}) => {
  const ctxTimeline = useContext(TimelineContext);
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(status);
  const [ritmoEcg, setRitmoEcg] = useState();

  const handlerAddOption = (option) => {
    setRitmoEcg(option);
  };

  const updateEcgContext = () => {
    ctxTimeline.ECG = ritmoEcg;
  };

  const handlerClose = () => {
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerSelect = () => {
    updateEcgContext();
    if (callbackConfirm) {
      callbackConfirm({
        ritmo: ritmoEcg,
        startAt: +new Date(),
        stopAt: +new Date(),
      });
    }
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);

  return (
    <>
      <FloatingDialog
        isOpen={isOpen}
        onClose={handlerClose}
        variant={"bottom"}
        headerIcon={icon}
        headerText={T(text)}
      >
        <div className="w-full">
          <div className="flex flex-1 w-full items-start  ">
            <div className="flex-col w-full h-full items-start justify-start  overflow-auto">
              <NSMultiSelector
                options={OptionsEvaluaRitmo}
                contexto={"monitor"}
                onCallBack={(opt) => handlerAddOption(opt)}
                initial={ritmoEcg}
                oneSelection={true}
                className={"grid grid-cols-1 gap-2 gap-y-2"}
                customColor={["#FEEFF2"]}
                customColorActive={["#F9839A"]}
                customInitial={4}
              />
            </div>
          </div>
          <div
            style={{
              marginBottom: isMobile ? "60px" : "0px",
              borderTop: "1px solid #e5e5e5",
            }}
            className=" flex pt-4 justify-center items-center w-full"
          >
            <SimpleButton disabled={!ritmoEcg} text={T("saveAndReturn")} onClick={handlerSelect} />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogEvaluaRitmo;
